/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import {
  checkFormHasError,
  getFormHelperText,
  handleBlurFormFormattedTextField,
  handleChangeFormFormattedTextField,
} from '@tock/shared/ui/forms/formHelpers';
import { useField, useFormikContext } from 'formik';
import FormattedTextField, { FormattedTextFieldProps } from 'ui/FormattedTextField';
import _ from 'lodash';

/**
 * Use `FormFormattedTextField` to have a text field in a formik based form with a filter to store the formatted value in the form state
 *
 * ```js
 * import { FormFormattedTextField } from 'ui';
 * ```
 */
function FormFormattedTextField({ helperText, filter, ...rest }: FormattedTextFieldProps) {
  const [field, meta] = useField(rest as any);
  const context = useFormikContext<any>();

  React.useEffect(() => {
    context.setFieldValue(field.name, _.toString(filter.parseViewValue(field.value)), false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    handleChangeFormFormattedTextField(
      event,
      field.name,
      filter,
      context.setFieldValue,
      rest.onChange
    );

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) =>
    handleBlurFormFormattedTextField(
      event,
      field.name,
      filter,
      context.setFieldValue,
      context.setFieldTouched,
      rest.onBlur
    );

  const hasError = checkFormHasError(meta);

  const helperTextValue = getFormHelperText(hasError, meta, helperText);

  return (
    <FormattedTextField
      id={rest.id ?? rest.name}
      filter={filter}
      error={hasError}
      helperText={helperTextValue}
      {...field}
      {...rest}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
}

export default FormFormattedTextField;
